<template>
    <div>
        <p :content="tooltipText" v-tippy="{theme : 'customTheme', placement: 'left', size: 'large'}">
            {{ text }}
        </p>
    </div>
</template>

<script>
export default {
    computed: {
		text() {
			return this.data[this.data.column.field]
		},
        tooltipText() {
            var text = "";

            var errorCodeText = this.data.loadCellErrorCode.toString().replace('-', '').replace('9', '');
            errorCodeText = errorCodeText.padStart(3, "0");

            if (errorCodeText[0] == '2' && errorCodeText[1] == '0' && errorCodeText[2] == '4') {
                text += 'Error: Division by zero';
                return text;
            }

            switch(errorCodeText[0]) {
                case '0':
                    text += 'Error: No Connection<br/>';
                    break;
                case '1':
                    text += 'Error: ADC<br/>';
                    break;
                case '2':
                    text += 'Error: Incorrect Weight<br/>';
                    break;
            }

            switch(errorCodeText[1]) {
                case '0':
                    text += 'Dlc: Not Used<br/>';
                    break;
                case '1': 
                case '2': 
                case '3': 
                    text += `Dlc: ${errorCodeText[1]}<br/>`;
                    break;
            }

            switch(errorCodeText[2]) {
                case '0':
                    text += 'Cell: Left';
                    break;
                case '1':
                    text += 'Cell: Right';
                    break;
            }

            return text;
        }
	},
    data: function() {
        return {
            data: {}
        }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Settings/LoadcellTooltipCell.vue